import { useAllCreditors } from '@debbie/cortex/dist/creditors/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useMissingApplicationCounts } from '@debbie/cortex/dist/integrations/index.js';
import React, { useMemo } from 'react';
import TodoPanel from '../../TodoPanel.js';
const EConomicTodos = (props) => {
    const counts = useMissingApplicationCounts();
    const creditorsLoadable = useAllCreditors();
    const creditors = h.hasData(creditorsLoadable) ? creditorsLoadable.data : null;
    const creditorNames = useMemo(() => {
        if (creditors == null) {
            return null;
        }
        return Object.fromEntries(creditors.map((c) => [c.creditorId, c.name]));
    }, [creditors]);
    return h.hasData(counts) &&
        creditorNames != null &&
        counts.data.length > 0 ? (React.createElement(TodoPanel, { heading: "E-conomic", data: [
            {
                path: '/e-conomic-mapper/',
                items: counts.data.map((item) => {
                    return {
                        id: item.creditorId,
                        header: creditorNames[item.creditorId],
                        small: item.count.toString(),
                        sortString: item.count.toString(),
                    };
                }),
            },
        ] })) : null;
};
export default EConomicTodos;
//# sourceMappingURL=EConomicTodos.js.map